import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import { Culture } from "../Data/Culture";
import * as Topics from "../Data/Topics";
import Gameplay from "../Gameplay";

function GetTextureForCulture(pCulture: Culture): PIXI.Texture {
    const textureName = "flag-" + HLF.NumberUtils.addZeroPadding(pCulture, 2);
    return HLF.PixiUtils.getTexture(textureName, Constants.SPRITESHEET_GAME);
}

export default class Flag extends PIXI.Sprite {
    protected _subscriptions: any[];

    constructor() {
        super(GetTextureForCulture(Gameplay.Instance.currentCulture));

        this._subscriptions = new Array<any>();
        this._subscriptions.push(
            PubSub.subscribe(Topics.CULTURE_CHANGE_BEGIN, this.onCultureChangeBegin.bind(this)),
            PubSub.subscribe(Topics.CULTURE_CHANGE_COMPLETE, this.onCultureChangeComplete.bind(this)),
        );
    }

    public destroy(pOptions?: boolean | PIXI.DestroyOptions) {
        this._subscriptions.forEach(PubSub.unsubscribe);
        super.destroy(pOptions);
    }

    protected onCultureChangeBegin(pTopic: string, pData: Culture): void {
        //
    }

    protected onCultureChangeComplete(pTopic: string, pData: Culture) {
        this.texture = GetTextureForCulture(pData);
    }
}
